<template>
  <div>
    <nav-breadcrumb :menu="[{label: '客户应收账款单据管理'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :multipleSelectionOperation="listMultipleSelectionOperation"
        :filters.sync="filters"
        :pageSize.sync="pageSize"
        :page.sync="page"
        class="xzmLR10"
      ></data-table>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {removeItem, xmlBuildQuery} from "../../../filters/CommonActions";

  export default {
    name: 'ServerAdminInvoiceList',
    data() {
      return {
        filterOptions: {
        },
        page: 1,
        pageSize: 10,
        listData: {},
        listMultipleSelectionOperation: [
        ],
        listColumns: [
          {
            name: '客户名称',
            field: 'c__customerName'
          },
          {
            name: '供应链',
            field: 'ct__debtorName'
          },
          {
            name: '单据类型',
            field: 'pi__invoiceType'
          },
          {
            name: '单据号码',
            field: 'pi__invoiceNo'
          },
          {
            name: '币种',
            field: '',
            formatter: function (r,c,v) {
              return '人民币'
            }
          },
          {
            name: '单据金额',
            field: 'pi__totalAmount'
          },
          {
            name: '质押金额',
            field: 'pi__pledgeAmount'
          },
          {
            label: '可融资金额',
            field: 'pi__balanceAmount'
          },
          {
            name: '单据日期',
            field: 'pi__invoiceDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '到期日',
            field: 'pi__dueDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '创建时间',
            field: 'pi__createdDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '状态',
            field: 'pi__invoiceStatus',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          // {
          //   name: '操作',
          //   opts:[
          //     {
          //       clickHandler: 'viewItem',
          //       class: 'el-icon-info',
          //       name: '查看'
          //     },
          //     {
          //       clickHandler: 'deleteItem',
          //       class: 'el-icon-delete',
          //       name: '删除'
          //     },
          //   ]
          // }
        ],
        filters: {
          form: {
            c__customerName: '',
            ct__debtorName: '',
            pi__invoiceNo: '',
            pi__invoiceDate: []
          },
          columns: [
            {
              label: '客户名称',
              component: 'el-input',
              field: 'c__customerName'
            },
            {
              label: '交易对手',
              component: 'el-input',
              field: 'ct__debtorName'
            },
            {
              label: '单据号码',
              component: 'el-input',
              field: 'pi__invoiceNo'
            },
            {
              label: '单据日期',
              component: 'date-range-picker',
              field: 'pi__invoiceDate'
            }
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerInvoiceList()
          }
        }
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.sort.dataField': 'pl.createdDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerInvoiceList()
      }
    },
    mounted() {
      this.getCustomerInvoiceList()
    },
    methods: {
      getCustomerInvoiceList: function () {
        xhr.getCustomerInvoiceList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
          try {
            this.listData = res.data
          }catch(e){

          }
        })

      },
      viewItem: function (index, row) {
        try {
          this.$router.push({path: 'InvoiceDetail?pi.invoiceId='+ row.pi__invoiceId})
        }
        catch (e) {

        }
      },
      deleteItem: function (index, row) {
        removeItem
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/InvoiceList.vue